<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2022-10-12 18:00:54
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-01-12 10:11:30
 * @FilePath: \seller.sviptrader.com\src\components\business\applySampleDrawer\components\confirmCooGoods\components\goodsBox.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="flex-row-align-center">
		<div class="pic mt-2">
			<el-avatar shape="square" :size="64" :src="row.productPic"></el-avatar>
		</div>
		<div class="details font-h6-regular ml-8">
			<div class="flex-row-align-center">
				<platform-icon :platformId="row.platform_id ? row.platform_id : platformId"></platform-icon>
				<el-tooltip placement="top" :content="row.productName" v-ak-tooltip-auto-show>
					<p class="yx-color-text-primary line-ellipsis ml-6" style="max-width: 180px">{{ row.productName }}</p>
				</el-tooltip>
			</div>
			<p class="goodsId-color mt-2">商品ID：{{ row.thirdProductId }}</p>
			<div class="shop-tag mt-4">
				<el-tooltip class="item" effect="dark" :content="row.shopName" :disabled="isTipShopName" placement="top">
					<span>店铺：{{ row.shopName | textFormat(14) | formatEmpty }}</span>
				</el-tooltip>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	components: {},
	props: {
		row: {
			type: Object,
			default: () => {},
		},
		platformId: {
			type: [Number, String],
			default: dataMap.PLATFORM_DY.value,
		},
	},
	data() {
		return {};
	},
	computed: {
		isTipShopName({ row }) {
			let name = row.shopName;
			return name && name.length > 6 ? false : true;
		},
	},
};
</script>
<style lang="less" scoped>
.shop-tag {
	height: 18px;
	line-height: 18px;
	border-radius: 2px;
	text-align: center;
	font-size: 12px;
	margin-top: 4px;
	display: inline-block;
	color: @color-gy7;
	img {
		width: 12px;
		height: 11px;
		margin-bottom: 2px;
		margin-right: 3px;
	}
}
.goodsId-color {
	color: @color-gy7;
}
</style>
